import React from "react";
import removeImg from "../../assets/svgs/close.svg";
import { Col, Row } from "react-bootstrap";
import MultiLangsWrapper from "../../components/shared/MultiLangsWrapper";

const SlidersArray = ({ sliders, setSliders }) => {
	const handleInputOnChange = (e, id) => {
		const { name, value } = e.target;
		const newSlidersArray = sliders.map(slider => {
			if (slider?.id !== id) return slider;

			// make an object with locals inside the big one
			const inputName = name?.split(".")?.[0];
			const local = name?.split(".")?.[1];

			if (local) {
				return {
					...slider,
					[inputName]: {
						...slider?.[inputName],
						[local]: value,
					},
				};
			}
			return { ...slider, [name]: value };
		});

		setSliders(newSlidersArray);
	};

	const removeSlider = sliderId => {
		const newSliders = sliders.filter(
			(slider, index) => slider?.id !== sliderId
		);
		setSliders(() => newSliders);
	};

	const addSlider = () => {
		// console.log("[...sliders, {}]", [...sliders, {}]);
		setSliders(() => [...sliders, { id: sliders?.length }]);
	};

	return (
		<div className="form-group branches sliders">
			<Row>
				<Col lg={12}>
					<h5 className="mb-3">الاجزاء</h5>

					{sliders?.map((slider, index) => {
						return (
							<label
								htmlFor={slider?.id}
								key={index}
								className="add-multi-component w-100 cursor-pointer"
							>
								<button
									type="button"
									onClick={() => removeSlider(slider?.id)}
									className="removeImg"
								>
									<img src={removeImg} alt="" />
								</button>
								<Row>
									<Col lg={12} className="check-show">
										<h5 className="mb-3">الصفحة : {slider?.pageName}</h5>
									</Col>
									<Col xs="12" md="6" className="check-show">
										<div className="form-group">
											<h5 className="mb-1">
												اسم الصفحة
												<p className="small" style={{ color: "inherit" }}>
													*يرجى عدم تغيير الاسم بعد الاضافة
												</p>
											</h5>
											<input
												type="text"
												name={`pageName`}
												className={`form-control form-outline`}
												onChange={e => handleInputOnChange(e, index)}
												value={slider?.pageName}
												disabled
											/>
										</div>
									</Col>
									<Col xs="12" md="6" className="check-show">
										<Row>
											<MultiLangsWrapper
												label={<label>العنوان</label>}
												customClass="form-group selectHolder col-12"
											>
												{({ lang, classes, key }) => (
													<input
														key={`${index}${key}`}
														type="text"
														name={`title.${lang}`}
														className={`form-control form-outline ${classes}`}
														onChange={e => handleInputOnChange(e, index)}
														value={slider?.title?.[lang]}
													/>
												)}
											</MultiLangsWrapper>
										</Row>
									</Col>{" "}
									{/* -------------------------- */}
									<Col xs="12" md="6" className="check-show">
										<Row>
											<MultiLangsWrapper
												label={<label>الوصف</label>}
												customClass="form-group selectHolder col-12"
											>
												{({ lang, classes, key }) => (
													<textarea
														key={`${index}${key}`}
														type="text"
														name={`description.${lang}`}
														style={{ height: "auto" }}
														className={`form-control form-outline ${classes}`}
														onChange={e => handleInputOnChange(e, index)}
														value={slider?.description?.[lang]}
													/>
												)}
											</MultiLangsWrapper>
										</Row>
									</Col>
									{/* -------------------------- */}
									<Col xs="12" md="6" className="check-show">
										<Row>
											<MultiLangsWrapper
												label={<label>الكلمات الدالة</label>}
												customClass="form-group selectHolder col-12"
											>
												{({ lang, classes, key }) => (
													<input
														key={`${index}${key}`}
														type="text"
														name={`keywords.${lang}`}
														className={`form-control form-outline ${classes}`}
														onChange={e => handleInputOnChange(e, index)}
														value={slider?.keywords?.[lang]}
													/>
												)}
											</MultiLangsWrapper>
										</Row>
									</Col>
								</Row>
							</label>
						);
					})}
				</Col>

				{/* <Col lg={4} xs={12} className="text-left mt-2">
					<button
						type="button"
						className="btn btn-green add_new_section__ mt-2"
						onClick={() => {
							addSlider();
						}}
					>
						اضافة جديد
					</button>
				</Col> */}
			</Row>
		</div>
	);
};

export default SlidersArray;
